import * as React from "react";
import * as DialogPrimitive from "@radix-ui/react-dialog";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import { cn } from "@/utils/cn";
import { cva } from "class-variance-authority";
const dialogVariants = cva("w-full bg-white data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 fixed top-[50%] left-[50%] z-[1002] grid max-w-[calc(100%-2rem)] translate-x-[-50%] translate-y-[-50%] gap-4 rounded-lg border p-6 shadow-lg duration-200", {
    variants: {
        size: {
            sm: "sm:max-w-sm",
            md: "sm:max-w-md",
            lg: "sm:max-w-2xl",
            xl: "sm:max-w-7xl",
            full: "sm:max-w-[calc(100%-2rem)]"
        }
    },
    defaultVariants: {
        size: "lg"
    }
});
function Dialog({ ...props }) {
    return React.createElement(DialogPrimitive.Root, { "data-slot": "dialog", ...props });
}
function DialogTrigger({ ...props }) {
    return React.createElement(DialogPrimitive.Trigger, { "data-slot": "dialog-trigger", ...props });
}
function DialogPortal({ ...props }) {
    return React.createElement(DialogPrimitive.Portal, { "data-slot": "dialog-portal", ...props });
}
function DialogClose({ ...props }) {
    return React.createElement(DialogPrimitive.Close, { "data-slot": "dialog-close", ...props });
}
function DialogOverlay({ className, ...props }) {
    return (React.createElement(DialogPrimitive.Overlay, { "data-slot": "dialog-overlay", className: cn("data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 fixed inset-0 z-[1002] bg-black/50", className), ...props }));
}
function DialogContent({ className, children, showCloseButton = true, size, ...props }) {
    return (React.createElement(DialogPortal, { "data-slot": "dialog-portal" },
        React.createElement(DialogOverlay, null),
        React.createElement(DialogPrimitive.Content, { "data-slot": "dialog-content", className: cn(dialogVariants({ size, className })), ...props },
            children,
            showCloseButton && (React.createElement(DialogPrimitive.Close, { "data-slot": "dialog-close", className: "ring-offset-background focus:ring-ring data-[state=open]:bg-accent data-[state=open]:text-muted-foreground absolute top-4 right-4 rounded-xs opacity-70 transition-opacity hover:opacity-100 focus:ring-2 focus:ring-offset-2 focus:outline-hidden disabled:pointer-events-none [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4" },
                React.createElement(FontAwesomeIcon, { icon: faXmark }),
                React.createElement("span", { className: "sr-only" }, "Close"))))));
}
function DialogHeader({ className, ...props }) {
    return (React.createElement("div", { "data-slot": "dialog-header", className: cn("flex flex-col gap-2 text-center sm:text-left", className), ...props }));
}
function DialogFooter({ className, ...props }) {
    return (React.createElement("div", { "data-slot": "dialog-footer", className: cn("flex flex-col-reverse gap-2 sm:flex-row sm:justify-between", className), ...props }));
}
function DialogTitle({ className, ...props }) {
    return (React.createElement(DialogPrimitive.Title, { "data-slot": "dialog-title", className: cn("text-lg leading-none font-semibold", className), ...props }));
}
function DialogDescription({ className, ...props }) {
    return (React.createElement(DialogPrimitive.Description, { "data-slot": "dialog-description", className: cn("text-muted-foreground text-sm", className), ...props }));
}
export { Dialog, DialogClose, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogOverlay, DialogPortal, DialogTitle, DialogTrigger };
